import _extends from "@babel/runtime/helpers/extends";
import CnErrorFeedback from '@cainiaofe/cn-error-feedback';
var _findConstruct = function findConstruct(response) {
  if (response && typeof response === 'object') {
    if ('success' in response) {
      return response;
    }
    return _findConstruct(response.data);
  }
  return {};
};
export default (function (response) {
  try {
    var data = _findConstruct(response);
    var success = data.success,
      errorMsg = data.errorMsg,
      _data$errorConstructI = data.errorConstructInfo,
      errorConstructInfo = _data$errorConstructI === void 0 ? {} : _data$errorConstructI,
      errorCode = data.errorCode;
    var _ref = errorConstructInfo || {},
      errorContentInfo = _ref.errorContentInfo;
    if (success === false && errorContentInfo) {
      // 调用信息反馈组件
      var instance = CnErrorFeedback.show(_extends({}, errorConstructInfo, {
        errorMsg: errorMsg,
        errorCode: errorCode
      }));
      if (typeof response === 'object' && response) {
        response.hadShowErrorFeedback = instance !== undefined && instance !== null;
      }
    }
  } catch (error) {
    // do nothing
  }
  return response;
});